export default __webpack_public_path__ + "locales/ko-KR/DeleteProfileEverDialog.json?hash=a77ce28dd1a0e60cf10106eeea94f94c";